import MenuItem from './MenuItem';

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-menu-item');
  const instances = [];

  elements.forEach(el => {
    const item = new MenuItem(el);
    item.mount();
    instances.push(item);
  });
});
